var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlano3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.79 324.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        opacity: .5;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        fill: none;\n        stroke: #000;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-11 {\n        stroke-width: .7px;\n      }\n\n      .cls-4 {\n        stroke-width: .59px;\n      }\n\n      .cls-5 {\n        stroke-width: .68px;\n      }\n\n      .cls-6 {\n        stroke-width: .49px;\n      }\n\n      .cls-7 {\n        stroke-width: .58px;\n      }\n\n      .cls-8 {\n        stroke-width: .55px;\n      }\n\n      .cls-9 {\n        stroke-width: .37px;\n      }\n\n      .cls-10, .cls-13 {\n        stroke-width: .23px;\n      }\n\n      .cls-11 {\n        stroke-linejoin: round;\n      }\n\n      .cls-12 {\n        stroke-width: .5px;\n      }\n\n      .cls-14 {\n        stroke-width: .54px;\n      }\n\n      .cls-15 {\n        stroke-width: .59px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.85,
    y1: 42.55,
    x2: 148.85,
    y2: 221.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 163.28,
    y1: 43.88,
    x2: 163.28,
    y2: 221.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.91,238.82c1.07-.11,126.5-18.81,126.5-18.81l206.71,28.6v1.23l-206.79-26.48-126.42,16.96v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.89,240.18c1.07-.11,125.44-16.82,125.44-16.82l205.81,26.36v1.22l-205.89-24.25-125.35,14.99v-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M31.94,241.43c1.05-.11,123.27-14.75,123.27-14.75l203.88,24v1.21l-203.96-21.92-123.19,12.93v-1.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "36.86 242.39 36.86 249.83 154.67 236.35 359.09 257.17 359.09 251.89 155.13 229.97 36.86 242.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "36.86 249.83 42.38 249.83 154.67 237.76 359.09 257.17 154.67 236.35 36.86 249.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "146.86 238.6 146.86 241.8 148.23 241.8 148.23 303.23 154.24 303.63 161.84 303.14 161.84 242.39 163.28 242.39 163.28 238.6 154.67 237.76 146.86 238.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "38.77 254.32 154.67 244.56 161.84 245.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "38.77 255.41 154.67 246.17 161.84 246.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "148.23 297.69 154.49 297.69 161.84 297.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 154.67,
    y1: 246.17,
    x2: 154.67,
    y2: 297.69
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "148.23 302.25 38.33 298.99 38.33 249.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120.75,241.41v60.03l-2.37.66v-56.55s-1.88-2.51-1.2-4.9l3.57.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.85,241.34c-.68,2.39,1.2,4.9,1.2,4.9v55.58l5.33.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M89.73,244.68v55.84l-2.21.61v-52.6s-1.76-2.33-1.13-4.56l3.34.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.67,244.74c-.63,2.23,1.13,4.56,1.13,4.56v51.7l3.72.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M89.73,244.68v55.84l-2.21.61v-52.6s-1.76-2.33-1.13-4.56l3.34.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.67,244.74c-.63,2.23,1.13,4.56,1.13,4.56v51.7l3.72.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M63.2,247.6v52.19l-1.83.61v-49.07s-1.45-1.97-.93-4.2l2.75.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M57.38,247.54c-.52,2.23.93,4.56.93,4.56v48.17l3.07.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.69,249.8v49.32l-1.75.59v-46.25s-1.38-1.86-.88-3.99l2.63.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M37.13,249.83c-.5,2.13.89,4.36.89,4.36v45.39l2.93.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 120.75,
    y1: 297.32,
    x2: 38.01,
    y2: 296.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 304.13,
    y1: 257.29,
    x2: 161.84,
    y2: 245.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 359.09,
    y1: 261.98,
    x2: 328.25,
    y2: 259.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 304.14,
    y1: 258.52,
    x2: 161.84,
    y2: 246.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 359.09,
    y1: 263.07,
    x2: 328.25,
    y2: 260.52
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "161.97 302.25 359.09 295.27 359.09 257.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M206.21,242.65v58.29l2.37.64v-54.81s1.88-2.46,1.2-4.8l-3.57.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M215.08,242c.68,2.34-1.18,5.46-1.18,5.46v53.87l-5.33.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M246.83,246.58v52.81l2.21.58v-49.56s1.72-2.06,1.08-4.18l-3.3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M253.85,246.45c.63,2.12-1.08,4.34-1.08,4.34v49.06l-3.72.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.33,249.3v49.11l1.83.59v-46.13s1.45-1.55.93-3.67l-2.75.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.15,249.24c.52,2.13-.93,3.9-.93,3.9v45.74l-3.07.12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 328.25,
    y1: 294.08,
    x2: 359.09,
    y2: 293.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 161.84,
    y1: 297.69,
    x2: 304.14,
    y2: 294.6
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "32.65 113.54 154.67 29.91 353.47 162.49 353.47 165.12 154.65 33.75 32.65 116.21 32.65 113.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "32.65 116.21 36.86 116.21 154.67 38.72 349.79 165.12 353.47 165.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 154.67,
    y1: 38.72,
    x2: 154.67,
    y2: 220.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 36.86,
    y1: 116.21,
    x2: 36.86,
    y2: 237.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 349.79,
    y1: 165.12,
    x2: 349.79,
    y2: 246.93
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 59.6,
    y1: 97.99,
    x2: 59.6,
    y2: 234.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "62.65 233.98 62.65 95.93 65.28 97.52 65.28 233.59"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.65,
    y1: 116.32,
    x2: 32.65,
    y2: 238.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "35.7 237.92 35.7 114.26 38.33 115.24 38.33 237.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 84.17,
    y1: 81.3,
    x2: 84.17,
    y2: 230.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "88.14 230.18 88.14 78.7 91.56 80.23 91.56 229.67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 114.28,
    y1: 60.89,
    x2: 114.28,
    y2: 225.91
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "118.25 225.67 118.25 58.3 121.67 60.43 121.67 225.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 281.9,
    y1: 117.74,
    x2: 281.9,
    y2: 237.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "278.85 237.08 278.85 115.68 276.22 117.54 276.22 236.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 308.84,
    y1: 135.45,
    x2: 308.84,
    y2: 241.23
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "305.79 240.81 305.79 133.58 303.17 134.83 303.17 240.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 328.25,
    y1: 148.14,
    x2: 328.25,
    y2: 243.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "325.2 243.5 325.2 146.27 322.58 147.52 322.58 243.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 353.47,
    y1: 164.83,
    x2: 353.47,
    y2: 247.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "350.42 246.99 350.42 162.96 347.8 164.21 347.8 246.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 251.65,
    y1: 97.81,
    x2: 251.65,
    y2: 233.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "247.68 232.8 247.68 95.22 244.26 96.74 244.26 232.33"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 213.6,
    y1: 72.67,
    x2: 213.6,
    y2: 228.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "209.63 227.51 209.63 70.08 206.21 72.21 206.21 227.07"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M342.3,255.58v40.4l1.75.59v-37.15s1.38-1.49.88-3.62l-2.63-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M347.87,256.02c.57,2.3-.89,3.62-.89,3.62v36.8l-2.93.12"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 58.31,
    y1: 265.07,
    x2: 42.69,
    y2: 265.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 58.31,
    y1: 288.74,
    x2: 42.69,
    y2: 288.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 58.31,
    y1: 290.02,
    x2: 42.69,
    y2: 290.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 44.49,
    y1: 265.86,
    x2: 44.49,
    y2: 288.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 63.2,
    y1: 288.54,
    x2: 83.8,
    y2: 288.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 63.2,
    y1: 289.72,
    x2: 83.8,
    y2: 289.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 63.2,
    y1: 264.68,
    x2: 83.8,
    y2: 263.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 65.52,
    y1: 264.59,
    x2: 65.59,
    y2: 288.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 89.73,
    y1: 263.69,
    x2: 113.32,
    y2: 263.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 89.73,
    y1: 288.15,
    x2: 112.73,
    y2: 288.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 89.73,
    y1: 289.4,
    x2: 113.06,
    y2: 289.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 92.02,
    y1: 263.63,
    x2: 92.02,
    y2: 287.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 120.75,
    y1: 262.38,
    x2: 148.23,
    y2: 261.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 133.24,
    y1: 262.2,
    x2: 133.24,
    y2: 301.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "122.72 264.28 131.33 264.28 131.33 290.97 123.18 290.97 122.72 264.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "134.82 264.28 134.82 290.97 146.32 290.97 146.32 264.02 134.82 264.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 206.21,
    y1: 292.49,
    x2: 161.84,
    y2: 293.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 161.97,
    y1: 290.97,
    x2: 206.21,
    y2: 290.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 161.97,
    y1: 261.26,
    x2: 206.21,
    y2: 261.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 204.31,
    y1: 261.62,
    x2: 204.31,
    y2: 290.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 213.9,
    y1: 261.98,
    x2: 246.51,
    y2: 263.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 213.9,
    y1: 289.99,
    x2: 246.83,
    y2: 289.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 213.9,
    y1: 291.83,
    x2: 246.83,
    y2: 291.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 244.74,
    y1: 263.07,
    x2: 244.74,
    y2: 289.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 252.76,
    y1: 289.8,
    x2: 276.33,
    y2: 289.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 252.76,
    y1: 291.83,
    x2: 276.33,
    y2: 291.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 252.76,
    y1: 263.07,
    x2: 276.33,
    y2: 263.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 274.85,
    y1: 263.65,
    x2: 274.85,
    y2: 289.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 304.13,
    y1: 251.92,
    x2: 304.13,
    y2: 297.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 328.25,
    y1: 254.03,
    x2: 328.25,
    y2: 296.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "308.33 297.07 308.33 256.74 324.69 257.97 324.69 296.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 281.22,
    y1: 289.8,
    x2: 304.13,
    y2: 289.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 281.22,
    y1: 291.56,
    x2: 304.13,
    y2: 291.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 281.22,
    y1: 263.65,
    x2: 304.13,
    y2: 264.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 302.52,
    y1: 264.73,
    x2: 302.52,
    y2: 289.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 328.25,
    y1: 265.96,
    x2: 342.3,
    y2: 266.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 328.25,
    y1: 289.03,
    x2: 342.3,
    y2: 289.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 328.25,
    y1: 290.17,
    x2: 342.3,
    y2: 290.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 340.87,
    y1: 266.58,
    x2: 340.87,
    y2: 288.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 54.01,
    y1: 119.76,
    x2: 54.01,
    y2: 139.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 54.01,
    y1: 148.32,
    x2: 54.01,
    y2: 168.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 54.01,
    y1: 179.3,
    x2: 54.01,
    y2: 199.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 54.01,
    y1: 208.02,
    x2: 54.01,
    y2: 227.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 322.66,
    y1: 296.56,
    x2: 322.66,
    y2: 257.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "165.55 250.79 165.09 258.52 202.17 259.15 202.17 252.35 165.55 250.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.07,250.79v7.74s-21.4.93-21.1.63c.3-.3-.2-6.22,0-6.51.2-.29,21.11-1.85,21.11-1.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.97 260.63 92.61 261.62 92.61 254.32 109.97 251.89 109.97 260.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "80.97 261.62 65.56 262.2 65.28 255.9 80.97 254.97 80.97 261.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "56.09 263.63 44.49 264.02 44.26 257.97 56.09 256.76 56.09 263.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "216.07 259.21 244.26 260.53 244.26 255.9 216.07 253.63 216.07 259.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "255.72 260.67 274.06 261.62 274.06 257.81 255.72 256.74 255.72 260.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "283.23 261.98 301.67 263.07 301.67 259.94 283.23 258.52 283.23 261.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "329.87 264.73 340.42 265.37 340.42 263.07 329.87 262.52 329.87 264.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "290.55 120.52 290.55 110.84 282.74 103.44 282.74 115.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 282.74,
    y1: 103.44,
    x2: 274.85,
    y2: 109.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "59.6 116.32 52.57 120.64 52.57 140.23 59.6 136.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "48.17 142.27 48.17 122.81 40.35 126.88 40.35 145.82 48.17 142.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 41.73,
    y1: 126.16,
    x2: 41.73,
    y2: 145.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "84.17 101.87 77.03 106.4 77.03 127.7 84.17 124.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "75.35 107.29 75.35 128.49 67.96 131.81 67.96 111.83 75.35 107.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 69.11,
    y1: 111.12,
    x2: 69.11,
    y2: 131.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 78.4,
    y1: 105.53,
    x2: 78.38,
    y2: 127.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "101.78 91.51 92.61 97.17 92.61 119.55 102.27 114.26 101.78 91.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "114.28 108.18 104.15 113.31 104.15 90.03 114.28 83.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 93.73,
    y1: 96.48,
    x2: 93.73,
    y2: 118.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 105.41,
    y1: 89.25,
    x2: 105.41,
    y2: 112.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "123.97 77.91 123.97 103.05 133.24 97.99 133.24 71.99 123.97 77.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "147.44 89.87 136.1 96.35 136.1 70.02 147.44 62.32 147.44 89.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 125.09,
    y1: 77.19,
    x2: 125.09,
    y2: 102.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 137.09,
    y1: 69.35,
    x2: 137.09,
    y2: 95.65
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "59.6 145.55 52.57 149.02 52.57 168.62 59.6 166.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "48.17 170.13 48.17 150.67 40.35 153.81 40.35 172.74 48.17 170.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 41.73,
    y1: 153.25,
    x2: 41.73,
    y2: 172.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "84.17 134.03 77.03 137.72 77.03 159.02 84.17 156.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "75.35 138.4 75.35 159.6 67.96 162.03 67.96 142.05 75.35 138.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 69.11,
    y1: 141.49,
    x2: 69.11,
    y2: 161.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 78.4,
    y1: 137.01,
    x2: 78.38,
    y2: 158.49
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "101.78 125.78 92.61 130.34 92.61 152.72 102.27 148.59 101.78 125.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "114.28 143.94 104.15 147.86 104.15 124.59 114.28 119.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 93.73,
    y1: 129.78,
    x2: 93.73,
    y2: 152.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 105.41,
    y1: 123.95,
    x2: 105.41,
    y2: 147.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "123.97 114.83 123.97 139.97 133.24 136.03 133.24 110.02 123.97 114.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "147.44 129.6 136.1 134.72 136.1 108.39 147.44 102.05 147.44 129.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 125.09,
    y1: 114.25,
    x2: 125.09,
    y2: 139.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 137.09,
    y1: 107.84,
    x2: 137.09,
    y2: 134.14
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "59.6 177.41 52.57 179.79 52.57 199.38 59.6 197.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "48.17 200.2 48.17 180.74 40.35 182.66 40.35 201.59 48.17 200.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 41.73,
    y1: 182.32,
    x2: 41.73,
    y2: 201.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "84.17 169.74 77.03 172.3 77.03 193.6 84.17 191.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "75.35 172.73 75.35 193.93 67.96 195.2 67.96 175.22 75.35 172.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 69.11,
    y1: 174.83,
    x2: 69.11,
    y2: 194.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 78.4,
    y1: 171.81,
    x2: 78.38,
    y2: 193.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "101.78 164.24 92.61 167.37 92.61 189.75 102.27 187.13 101.78 164.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "114.28 184.36 104.15 186.69 104.15 163.42 114.28 159.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 93.73,
    y1: 166.98,
    x2: 93.73,
    y2: 189.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 105.41,
    y1: 162.98,
    x2: 105.41,
    y2: 186.31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "123.97 156.76 123.97 181.9 133.24 179.4 133.24 153.4 123.97 156.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "147.44 175.2 136.1 178.54 136.1 152.21 147.44 147.65 147.44 175.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 125.09,
    y1: 156.35,
    x2: 125.09,
    y2: 181.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 137.09,
    y1: 151.82,
    x2: 137.09,
    y2: 178.12
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "59.6 206.25 52.57 208.48 52.57 228.07 59.6 226.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "48.17 228.8 48.17 209.34 40.35 211.1 40.35 230.04 48.17 228.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 41.73,
    y1: 210.79,
    x2: 41.73,
    y2: 229.87
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "84.17 201.45 77.03 203.64 77.03 224.94 84.17 223.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "75.35 203.97 75.35 225.18 67.96 226.06 67.96 206.08 75.35 203.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 69.11,
    y1: 205.75,
    x2: 69.11,
    y2: 225.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 78.4,
    y1: 203.22,
    x2: 78.38,
    y2: 224.69
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "101.78 198.13 92.61 200.33 92.61 222.71 102.27 221.07 101.78 198.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "114.28 219.51 104.15 220.82 104.15 197.55 114.28 195.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 93.73,
    y1: 200.06,
    x2: 93.73,
    y2: 222.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 105.41,
    y1: 197.24,
    x2: 105.41,
    y2: 220.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "123.97 192.9 123.97 218.04 133.24 216.48 133.24 190.48 123.97 192.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "147.44 213.72 136.1 215.91 136.1 189.58 147.44 186.17 147.44 213.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 125.09,
    y1: 192.6,
    x2: 125.09,
    y2: 218.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 137.09,
    y1: 189.29,
    x2: 137.09,
    y2: 215.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "229.56 98.65 241.65 106.63 241.82 127.86 229.09 120.54 229.56 98.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "213.28 111.51 226.63 119.15 226.44 96.53 213.6 87.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 240.17,
    y1: 105.67,
    x2: 240.35,
    y2: 126.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 224.78,
    y1: 95.39,
    x2: 224.96,
    y2: 118.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "229.83 131.8 241.91 138.1 242.08 159.34 229.37 153.78 229.83 131.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "213.57 147.02 226.9 152.74 226.72 130.12 213.37 122.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 240.43,
    y1: 137.34,
    x2: 240.61,
    y2: 158.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 225.05,
    y1: 129.21,
    x2: 225.24,
    y2: 151.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "230.14 169 242.2 173.23 242.37 194.46 229.67 191.09 230.14 169"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "213.9 187.14 227.21 190.48 227.02 167.86 213.7 162.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 240.72,
    y1: 172.72,
    x2: 240.89,
    y2: 193.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 225.36,
    y1: 167.25,
    x2: 225.55,
    y2: 190
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "281.9 130.47 288.8 135.1 288.8 152.63 281.9 148.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "293.12 154.88 293.12 137.51 300.8 141.96 300.8 158.79 293.12 154.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 299.44,
    y1: 141.18,
    x2: 299.44,
    y2: 158.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 287.39,
    y1: 134.16,
    x2: 287.39,
    y2: 151.83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "281.9 156.73 288.8 160.51 288.79 178.04 281.9 175.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "293.12 179.76 293.12 162.38 300.8 165.89 300.79 182.71 293.12 179.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 299.44,
    y1: 165.27,
    x2: 299.44,
    y2: 182.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 287.39,
    y1: 159.74,
    x2: 287.39,
    y2: 177.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "281.9 185.36 288.79 188.04 288.79 205.58 281.9 203.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "293.12 206.6 293.12 189.23 300.79 191.52 300.79 208.34 293.12 206.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 299.44,
    y1: 191.12,
    x2: 299.44,
    y2: 208.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 287.39,
    y1: 187.5,
    x2: 287.39,
    y2: 205.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "281.9 211.27 288.79 213.72 288.79 231.26 281.9 229.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "293.11 232.14 293.12 214.77 300.79 216.79 300.79 233.62 293.11 232.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 299.44,
    y1: 216.44,
    x2: 299.44,
    y2: 233.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 287.39,
    y1: 213.23,
    x2: 287.39,
    y2: 230.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "308.85 147.88 313.35 150.86 313.35 166.44 308.84 164.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "316.18 167.88 316.18 152.38 321.19 155.36 321.19 170.49 316.18 167.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 320.31,
    y1: 154.83,
    x2: 320.31,
    y2: 170.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 312.43,
    y1: 150.24,
    x2: 312.43,
    y2: 165.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "308.84 171 313.35 173.43 313.35 189 308.84 187.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "316.18 190.08 316.18 174.58 321.19 176.88 321.19 192.01 316.18 190.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 320.31,
    y1: 176.47,
    x2: 320.31,
    y2: 191.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 312.43,
    y1: 172.93,
    x2: 312.43,
    y2: 188.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "308.84 196.21 313.35 197.88 313.35 213.46 308.84 212.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "316.17 214.05 316.18 198.54 321.19 199.94 321.19 215.07 316.17 214.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 320.31,
    y1: 199.69,
    x2: 320.31,
    y2: 214.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 312.43,
    y1: 197.54,
    x2: 312.43,
    y2: 213.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "308.84 219.02 313.35 220.69 313.35 236.27 308.84 235.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "316.17 236.84 316.17 221.33 321.19 222.67 321.19 237.8 316.17 236.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 320.31,
    y1: 222.43,
    x2: 320.31,
    y2: 237.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 312.43,
    y1: 220.35,
    x2: 312.43,
    y2: 236.01
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "328.32 157.16 334.78 161.89 334.78 176.18 328.32 172.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "338.83 178.46 338.83 164.41 346.02 168.93 346.02 182.37 338.83 178.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 344.75,
    y1: 168.14,
    x2: 344.75,
    y2: 181.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 333.47,
    y1: 160.94,
    x2: 333.47,
    y2: 175.37
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "328.32 178.8 334.78 182.59 334.78 196.88 328.32 194.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "338.83 198.58 338.83 184.53 346.02 188.04 346.02 201.48 338.83 198.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 344.75,
    y1: 187.43,
    x2: 344.75,
    y2: 201.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 333.47,
    y1: 181.83,
    x2: 333.47,
    y2: 196.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "328.32 202.39 334.78 205.02 334.78 219.31 328.32 217.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "338.83 220.3 338.83 206.25 346.02 208.52 346.02 221.96 338.83 220.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 344.75,
    y1: 208.12,
    x2: 344.75,
    y2: 221.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 333.46,
    y1: 204.49,
    x2: 333.46,
    y2: 218.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "328.32 223.74 334.78 225.94 334.78 240.23 328.32 238.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "338.83 240.96 338.83 226.9 346.02 228.71 346.02 242.15 338.83 240.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 344.75,
    y1: 228.4,
    x2: 344.75,
    y2: 241.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 333.46,
    y1: 225.5,
    x2: 333.46,
    y2: 239.93
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "251.35 114.26 261.67 120.78 261.74 140.09 251.43 134.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "264.1 122.12 264.16 141.27 274.85 146.27 274.78 128.51 264.1 122.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 273.12,
    y1: 127.52,
    x2: 273.18,
    y2: 145.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 259.69,
    y1: 119.54,
    x2: 259.79,
    y2: 139.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "251.46 143.87 261.77 149.16 261.84 168.47 251.53 164.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "264.2 150.22 264.26 169.37 274.94 173.14 274.88 155.38 264.2 150.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 273.21,
    y1: 154.58,
    x2: 273.28,
    y2: 172.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 259.79,
    y1: 148.15,
    x2: 259.89,
    y2: 167.69
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "251.58 176.73 261.89 180.51 261.96 199.82 251.65 197.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "264.31 181.22 264.37 200.37 275.05 202.62 274.98 184.86 264.31 181.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 273.32,
    y1: 184.3,
    x2: 273.38,
    y2: 202.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 259.9,
    y1: 179.79,
    x2: 260.01,
    y2: 199.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "251.68 205.91 261.99 208.91 262.06 228.22 251.75 226.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "264.41 209.44 264.48 228.59 275.14 230.05 275.08 212.29 264.41 209.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 273.42,
    y1: 211.85,
    x2: 273.48,
    y2: 229.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 260.01,
    y1: 208.34,
    x2: 260.11,
    y2: 227.87
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "230.41 201.78 242.45 204.5 242.63 225.73 229.94 223.96 230.41 201.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "214.18 222.05 227.48 223.66 227.3 201.04 213.98 197.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 240.98,
    y1: 204.17,
    x2: 241.15,
    y2: 225.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 225.64,
    y1: 200.64,
    x2: 225.82,
    y2: 223.39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "203.77 85.31 203.82 109.57 188.62 101.71 188.57 76.14 203.77 85.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "165.34 88.77 183.93 99.15 183.88 73.11 165.28 60.89 165.34 88.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 201.93,
    y1: 84.21,
    x2: 201.98,
    y2: 108.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.26,
    y1: 72.06,
    x2: 182.31,
    y2: 98.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "203.84 120.93 203.9 145.19 188.7 139.11 188.65 113.54 203.84 120.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "165.43 128.99 184.01 137.1 183.96 111.06 165.37 101.1 165.43 128.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 202.01,
    y1: 120.05,
    x2: 202.06,
    y2: 144.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.34,
    y1: 110.21,
    x2: 182.39,
    y2: 136.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "203.93 161.38 203.98 185.64 188.79 181.76 188.74 156.19 203.93 161.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "165.52 175.14 184.11 180.45 184.05 154.41 165.46 147.26 165.52 175.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 202.09,
    y1: 160.76,
    x2: 202.14,
    y2: 185.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.43,
    y1: 153.8,
    x2: 182.49,
    y2: 179.87
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "204 196.25 204.05 220.51 188.87 218.23 188.82 192.65 204 196.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "165.61 214.13 184.18 217.41 184.13 191.37 165.55 186.25 165.61 214.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 202.17,
    y1: 195.82,
    x2: 202.22,
    y2: 220.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.51,
    y1: 190.93,
    x2: 182.56,
    y2: 217.01
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.59,119.76C57.1,81.05,114.06,38.02,165.09,0,114.58,38.71,57.62,81.74,6.59,119.76h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.28,3.01c84.76,55.95,179.58,119.12,263.87,175.79C293.38,122.85,198.57,59.67,114.28,3.01h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.77,240.49c111.26-17.15,236.14-35.92,347.52-52.22-111.26,17.16-236.14,35.92-347.52,52.22h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.79,293.73s-284.82,30.61-284.82,30.61c.13.69,286.75-32.87,284.82-30.61h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.02,300.05l201.91,24.71c-.01-.69-204.27-22.95-201.91-24.71H.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.94,247.8l.35-220.91c-.69.1,1.68,223.04-.35,220.91h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.86,42.55c.57,86.5.58,183.53,0,270.02-.58-86.5-.57-183.53,0-270.02h0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlano3);
export default __webpack_public_path__ + "static/media/plano3.a21b83ada20c7dcf73b19b16be2d31c7.svg";
export { ForwardRef as ReactComponent };